import ReminderTranslationResponse from '../../../../../Spirit/Admin/Interfaces/Models/ReminderService/ReminderTranslationResponse';

export default class ReminderUpdateRequest  {
	Id?: number = null;
	Translations: Array<ReminderTranslationResponse> = null;
	constructor(obj?: Partial<ReminderUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
